export default class WarehouseAdminSimpleProductReportRequest {
    toJson(): Record<string, never> {
        return {};
    }
}